import config from 'src/config';
import { ResponseDto } from 'src/dtos/common/responseDto';
import { getData, patchData } from 'src/utils/axios/serverHelper';
import {
    HRM1040_R01Dto,
    HRM1040_R01HeaderDto,
    HRM1040_R01FamilyDto,
    HRM1040_R01EducationDto,
} from './Dto_HRM1040_R01';
import { HRM1040_R01Filter } from './Store_HRM1040_R01';

/** HRM1040_R01 화면의 API 기본 경로이다. */
const BASE_URL = `${config.apiUrl}/HRM1040_R01`;

/**
 * 조건에 맞는 사원 목록을 가져온다.
 * @param option search(새 조회) 또는 refetch(저장 후 재조회)
 * @param params 사업장·부서·재직상태·사원 검색 조건. 빈 값은 undefined로 넘겨 요청에서 뺀다.
 * @param listLength 요청에 포함하지만 현재 백엔드 목록 쿼리에서는 사용하지 않는 목록 길이(HRM 화면 공통 형태)
 * @returns 사원 목록 응답
 */
export const getHRM1040_R01List = async (option: string, params: Partial<HRM1040_R01Filter>, listLength = 0) =>
    await getData<ResponseDto<HRM1040_R01HeaderDto[]>>(`${BASE_URL}/header/${option}`, { params: { ...params, listLength } });

/**
 * 조건에 맞는 사원 수를 가져온다.
 * @param params 목록 조회와 같은 검색 조건
 * @returns 전체 사원 수 응답
 */
export const getHRM1040_R01AllCount = async (params: Partial<HRM1040_R01Filter>) =>
    await getData<ResponseDto<number>>(`${BASE_URL}/header/allCount`, { params: { ...params } });

/**
 * 사원의 가족관계 목록을 가져온다.
 * @param empNo 사원번호. 경로에 들어가므로 특수문자를 인코딩한다.
 * @returns 가족관계 목록 응답
 */
export const getHRM1040_R01FamilyList = async (empNo: string) =>
    await getData<ResponseDto<HRM1040_R01FamilyDto[]>>(`${BASE_URL}/family/${encodeURIComponent(empNo)}`);

/**
 * 사원의 학력 목록을 가져온다.
 * @param empNo 사원번호
 * @returns 학력 목록 응답
 */
export const getHRM1040_R01EducationList = async (empNo: string) =>
    await getData<ResponseDto<HRM1040_R01EducationDto[]>>(`${BASE_URL}/education/${encodeURIComponent(empNo)}`);

/**
 * 사원 한 명의 가족과 학력을 함께 저장한다.
 * @param data 사원번호와 저장 후 남길 가족·학력 전체 목록
 * @returns 저장 결과 응답
 */
export const patchHRM1040_R01 = async (data: HRM1040_R01Dto) =>
    await patchData<HRM1040_R01Dto, ResponseDto<HRM1040_R01Dto>>(BASE_URL, data);

/**
 * 사원의 가족관계 Excel을 받는다.
 * @param empNo 사원번호
 * @returns Excel 파일 데이터 응답
 */
export const downloadExcel_HRM1040_R01Family = async (empNo: string) =>
    await getData<ResponseDto<string>>(`${BASE_URL}/family/${encodeURIComponent(empNo)}/excel`);

/**
 * 사원의 학력 Excel을 받는다.
 * @param empNo 사원번호
 * @returns Excel 파일 데이터 응답
 */
export const downloadExcel_HRM1040_R01Education = async (empNo: string) =>
    await getData<ResponseDto<string>>(`${BASE_URL}/education/${encodeURIComponent(empNo)}/excel`);
